import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import OrdersData from "../components/OrdersData";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from "react-i18next";

const OrdersPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Redirect unauthenticated users
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={t('orders.your_orders') || 'Your Orders'} />

      {/* Main Content */}
      <section className="orders py-80">
        <div className="container container-lg">
          <div className="row">
            <div className="col-12">
              <div className="px-40 py-48 border border-gray-100 orders-table rounded-8">
                <h6 className="mb-32 text-xl">{t('orders.order_history') || 'Order History'}</h6>
                <OrdersData />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default OrdersPage; 